<template>
  <div class="modal-body-reset-password">
    <div class="description">
      Reset password by entering the information below.
    </div>
    <div class="field-wrapper">
      <div class="text">Current password:</div>
      <div>
        <input v-validate="'required'" data-vv-as="old password" name="oldPassword" class="input" type="password"
               v-model="resetPasswordInfo.oldPassword"
               @blur="validateInput('oldPassword')">
      </div>
      <div class="errorBackground" :class="{errorBackgroundColor : errors.has('oldPassword') && validatedFields.includes('oldPassword')}">
        <span v-if="validatedFields.includes('oldPassword')" class="errorDetail" v-show="errors.has('oldPassword')">{{ errors.first('oldPassword') }}</span>
      </div>
    </div>
    <div class="field-wrapper">
      <div class="text">New Password:</div>
      <div>
        <input class="input" data-vv-as="new password" name="newPassword" type="password"
               v-model="resetPasswordInfo.newPassword"
               v-validate="'required'"
               @blur="validateInput('newPassword')">
      </div>
      <div class="errorBackground" :class="{errorBackgroundColor : errors.has('newPassword') && validatedFields.includes('newPassword') || !isPasswordContainsNumber}">
        <span v-if="validatedFields.includes('newPassword')" class="errorDetail" v-show="errors.first('newPassword')">{{ errors.first('newPassword') }}</span>
        <span v-if="!isPasswordContainsNumber && !errors.has('newPassword')" class="errorDetail">The New password must contains at least 1 digit</span>
      </div>
    </div>
    <div class="field-wrapper">
      <div class="text">Confirm New Password:</div>
      <div>
          <input type="password" data-vv-as="confirm password" name="repeatPassword" class="input"
                 v-model="resetPasswordInfo.repeatPassword"
                 v-validate="{ required: true, confirmed: resetPasswordInfo.newPassword }"
                 @blur="validateInput('repeatPassword')">
      </div>
      <div class="errorBackground" :class="{errorBackgroundColor : errors.has('repeatPassword') && validatedFields.includes('repeatPassword')}">
        <span v-if="validatedFields.includes('repeatPassword')" class="errorDetail" v-show="errors.has('repeatPassword')">{{ errors.first('repeatPassword') }}</span>
      </div>
    </div>
    <div class="password-check-list">
      <div class="password-at-least">Password must have at least:</div>
      <div class="indicators-password row">
        <div class="indicator-item col-lg-6">
          <div class="icon-wrapper" :style="hiddenIconPasswordIndicator">
            <div class="icon-reach" v-if="passwordCheckList.length"></div>
            <div class="icon-unreach" v-else></div>
          </div>
          <div class="text">8 characters </div>
        </div>
        <div class="indicator-item col-lg-6">
          <div class="icon-wrapper" :style="hiddenIconPasswordIndicator">
            <div class="icon-reach" v-if="passwordCheckList.lowerCaseChars"></div>
            <div class="icon-unreach" v-else></div>
          </div>
          <div class="text">4 lowercase letters (a-z)</div>
        </div>
        <div class="indicator-item col-lg-6">
          <div class="icon-wrapper" :style="hiddenIconPasswordIndicator">
            <div class="icon-reach" v-if="passwordCheckList.upperCaseChars"></div>
            <div class="icon-unreach" v-else></div>
          </div>
          <div class="text">1 uppercase letter (A-Z)</div>
        </div>
        <div class="indicator-item col-lg-6">
          <div class="icon-wrapper" :style="hiddenIconPasswordIndicator">
            <div class="icon-reach" v-if="passwordCheckList.numbers"></div>
            <div class="icon-unreach" v-else></div>
          </div>
          <div class="text">2 numbers (0-9)</div>
        </div>
        <div class="indicator-item col-lg-6">
          <div class="icon-wrapper" :style="hiddenIconPasswordIndicator">
            <div class="icon-reach" v-if="passwordCheckList.specialChars"></div>
            <div class="icon-unreach" v-else></div>
          </div>
          <div class="text">1 special character</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import validator from '@/utils/validator';
Vue.use(VeeValidate);

export default {
  name: 'reset-password-body-modal',
  data () {
    return {
      validatedFields: [],
      isPasswordContainsNumber: true,
      passwordError: [],
      passwordCheckList: {
        length: false,
        lowerCaseChars: false,
        upperCaseChars: false,
        numbers: false,
        specialChars: false
      }
    };
  },
  props: {
    resetPasswordInfo: {
      type: Object,
      default: {}
    }
  },
  computed: {
    hiddenIconPasswordIndicator () {
      return {
        visibility: this.resetPasswordInfo.newPassword === '' ? 'hidden' : 'visible'
      };
    }
  },
  methods: {
    validateInput (field) {
      if (!this.validatedFields.includes(field)) {
        this.validatedFields.push(field);
      }

      this.$validator.validate().then(result => {
        let summary = validator.isPasswordValid(this.resetPasswordInfo.newPassword).summary;
        this.$emit('disableBtnRight', !(summary && result));
      });
      // this.passwordCheckList = validator.isPasswordValid(this.resetPasswordInfo.newPassword);
    }
  },
  created () {
    this.$emit('disableBtnRight', true);
  },
  watch: {
    'resetPasswordInfo.newPassword': {
      handler: function () {
        this.passwordCheckList = validator.isPasswordValid(this.resetPasswordInfo.newPassword).detail;
      }
    }
  }
}
</script>

<style lang="less">
  .modal-body-reset-password{
    color: #231F20;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    margin-bottom: 60px;
    .description{
      line-height: 14px;
    }
    .input{
      height: 38px;
      border: 1px solid #d9d9d9;
      border-radius: 3px;
      padding-left: 12px;
    }
    .name{
      margin: 30px 0 0 0;
      .last-name{
        margin-left: 40px;
        .text{}
        .input{
          width: 275px;
        }
      }
      .first-name{
        .text{}
        .input{
          width: 275px;
        }
      }
    }
    .field-wrapper{
      margin: 30px 0 0 0;
      .text{}
      .input{
        width: 590px;
      }
    }
    .errorBackground {
      width: 588px;
      height: 21px;
      margin-top: 1px;
    }
    .errorDetail {
      height: 17px;
      width: 108px;
      color: #803939;
      font-family: "Open Sans",serif;
      font-size: 12px;
      line-height: 17px;
      text-align: right;
      margin-left: 5px;
    }
    .errorBackgroundColor {
      background-color: #FEE2E2;
    }
  }
</style>




// WEBPACK FOOTER //
// ResetPasswordModal.vue?a58c9d6a